import * as React from "react"

const Spacer = () => {
  return (
  <div className='spacer' />
  )
}
export default Spacer
